// eslint-disable-next-line @typescript-eslint/no-namespace
import { BandmanagerRestApiProfileDto } from '@digitale-menschen/bandmanager-rest-api';

export namespace UserStateActions {

  export class SetIsLoggedIn {
    static readonly type = '[User] SetIsLoggedIn';

    constructor(public isLoggedIn: boolean) {
    }
  }

  export class SetAuthToken {
    static readonly type = '[User] SetAuthToken';

    constructor(public authToken: string) {
    }
  }

  export class SetRefreshToken {
    static readonly type = '[User] SetRefreshToken';

    constructor(public refreshToken: string) {
    }
  }

  export class DeleteTokens {
    static readonly type = '[User] DeleteTokens';

    constructor() {
    }
  }

  export class DeleteUser {
    static readonly type = '[User] DeleteUser';

    constructor() {
    }
  }
}
